"use client";

import Image from "next/image";
import { useState } from "react";
import type { SiteSettings } from "@/lib/fleet-server";
import { useLocale } from "@/lib/locale-context";
import { track } from "@/lib/metrika";

const FALLBACK = {
  image: "/images/bottom-about.png",
  text:
    "Сеть автопрокатов класса А в России и мире Приветствуем вас на главном сайте компании «Автопилот» — сервисе по аренде авто в городах России и за её пределами. Здесь вы сможете в несколько нажатий найти автомобиль или микроавтобус любого класса в аренду — как с водителем, так и без. «Автопилот» — это недорогая аренда, организация трансферов из транспортных гаваней и другие услуги, востребованные у частных лиц, представителей бизнеса, региональных и федеральных учреждений. Почему именно «Автопилот»? За долгие годы работы в сегменте аренды транспортных средств компания «Автопилот» создала целый пул уникальных предложений и условий для аренды автомобилей. Предлагаем вам ознакомиться с ключевыми преимуществами заказа автомобиля в компании в целом и на данном сайте в частности:",
};

export default function BottomAbout({ data }: { data?: SiteSettings["bottom_about"] }) {
  const { t, locale } = useLocale();
  const [open, setOpen] = useState(false);
  const image = data?.image || FALLBACK.image;
  const pick = (ru?: string, en?: string) => (locale === "en" && en && en.trim() ? en : ru || "");
  const text = pick(data?.text_ru, data?.text_en) || FALLBACK.text;
  const more = pick(data?.more_ru, data?.more_en).trim();

  return (
    <div className="grid gap-6 lg:grid-cols-[381px_1fr] lg:gap-6">
      <div className="relative aspect-square w-full overflow-hidden rounded-3xl bg-surface-2 lg:size-[381px] lg:aspect-auto lg:h-[323px]">
        <Image src={image} alt="Автопилот" fill sizes="(max-width: 1024px) 100vw, 381px" className="object-cover" />
      </div>
      <div className="flex flex-col gap-3 lg:gap-[16px]">
        <p className="text-[14px] leading-[1.5] text-accent/90 sm:text-[15px] lg:text-[16px] lg:leading-[24px]" style={{ whiteSpace: "pre-line" }}>
          {text}
          {more && open ? `\n\n${more}` : ""}
        </p>
        {more && (
          <button
            type="button"
            onClick={() => { if (!open) track("faq_toggle"); setOpen((o) => !o); }}
            className="self-start text-[14px] font-medium leading-[1.3] text-primary transition hover:underline lg:text-[16px]"
          >
            {open ? t("bottom.collapse") : t("bottom.readMore")}
          </button>
        )}
      </div>
    </div>
  );
}
